module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dac5e2ae!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-slick/slickCarousel.vue
// module id = 2137
// module chunks = 2